import styles from '@components/components/CmsComponents/components/CmsContactForm/components/Step1/Step1.module.scss';
import ContactFormFieldRender from '@components/components/CmsComponents/components/CmsContactForm/components/ContactFormFieldRenderer/ContactFormFieldRenderer';
import React from 'react';
import { Button } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import { FormLabel, FormInput, FormSubmit } from '@ariakit/react';

const Step1 = ({ store, contact }) => (
  <>
    <ContactFormFieldRender contact={contact} store={store} />

    {/* h o n e y p o t s Field */}
    <div aria-hidden="true" className={classNames(styles.row, styles.email)}>
      <FormLabel name="email" store={store}>
        Email
      </FormLabel>
      <FormInput
        autoComplete="off"
        name="email"
        placeholder="Please enter your email"
        store={store}
        tabIndex={-1}
        type="email"
      />
    </div>

    <FormSubmit
      className={styles.button}
      data-purpose="button-submit"
      render={<Button isElevated>{contact.cta}</Button>}
    />
  </>
);
export default Step1;
